import Immutable from 'immutable';
import {
  FLAG_GETTING_FUEL_VOUCHERS,
  GET_FUEL_VOUCHERS,
  CLEAR_FUEL_VOUCHERS,
  FLAG_FUEL_VOUCHER_ACTIVITY,
  GET_FUEL_VOUCHER,
  CLEAR_FUEL_VOUCHER,
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_FUEL_VOUCHERS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_FUEL_VOUCHERS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_FUEL_VOUCHERS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_FUEL_VOUCHER_ACTIVITY:
      // raising flag
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      // lowering flag
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_FUEL_VOUCHER:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_FUEL_VOUCHER:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
